import { render, staticRenderFns } from "./CartPayPage.vue?vue&type=template&id=b7e8ca46"
import script from "./CartPayPage.vue?vue&type=script&lang=js"
export * from "./CartPayPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports